export default __webpack_public_path__ + "static/media/Dusk_Towers.00f307c8.jpg";